import { Region, RegionEnum, RegionSchema } from '@watershed/config/types';
import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

export function getRegionFromFrontend(): Region {
  return RegionSchema.parse(getPublicRuntimeConfig('NEXT_PUBLIC_REGION'));
}

export const REGIONS_ORDERED = [...RegionEnum.options].sort();
